module.exports = __webpack_public_path__ + "img/d4a5b.78c26313.svg";